import { render } from "./BatchGen.vue?vue&type=template&id=532ad5e6"
import script from "./BatchGen.vue?vue&type=script&lang=js"
export * from "./BatchGen.vue?vue&type=script&lang=js"

import exportComponent from "/Users/davidchou/Documents/Programming/vue/cvicloud-app-states-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__